import { type ClassValue, clsx } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export function getFlagEmoji(countryCode: string) {
  if (!countryCode) return "";
  const codePoints = countryCode
    .toUpperCase()
    .split("")
    .map((char) => 127397 + char.charCodeAt(0));
  return String.fromCodePoint(...codePoints);
}

export function getOrdinal(n: number) {
  const rounded = Math.round(n);
  const s = ["th", "st", "nd", "rd"];
  const v = rounded % 100;
  const suffix = s[(v - 20) % 10] || s[v] || s[0];
  
  // If it's a float, show the decimal but keep the ordinal suffix of the rounded version? 
  // Probably just showing the rounded version is cleaner for a "rank".
  // Or if it's 1.2, show "1.2". 
  // Let's just return the formatted string.
  return n % 1 === 0 ? `${n}${suffix}` : `${n.toFixed(1)}${suffix}`;
}

/**
 * Adds or overrides utm_source=42a.ai on a URL so external websites
 * can attribute traffic coming from our platform.
 */
export function withUtmSource(url: string): string {
  try {
    const u = new URL(url);
    u.searchParams.set('utm_source', '42a.ai');
    return u.toString();
  } catch {
    return url;
  }
}
